class AnnouncementBar extends HTMLElement {
    constructor() {
        super();

    }

    connectedCallback() {
        this.enableSwiper();
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.offsetHeight}px`);
    }

    enableSwiper() {
        const configuration =  {
            slidesPerView: "auto",
            loop: true,
            draggable: true,
            speed: 15000,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
            }
        }

        new Swiper(this.querySelector('.swiper-container'), configuration);
    }
}
customElements.define('announcement-bar', AnnouncementBar);



